module.exports = {
      id: "scroll-circle-usage",
      viewBox: "0 0 79.14 79.55",
      url: __webpack_public_path__ + "img/icons.91580017.svg#scroll-circle-usage",
      toString: function () {
        return this.url;
      }
    }